import {Component} from 'lowkey-component'

export class Hover extends Component {
  private triggerElements: Element[] = []

  constructor(element: HTMLElement) {
    super(element)
    this.onMouseEnter = this.onMouseEnter.bind(this)
    this.onMouseLeave = this.onMouseLeave.bind(this)
  }

  didMount() {

    const {trigger} = this.element?.dataset || {}

    if (this.element) {
      this.triggerElements = trigger
                             ? [...this.element.querySelectorAll(trigger)]
                             : [this.element]
    }

    this.triggerElements.map(triggerElement => {
      triggerElement.addEventListener('mouseenter', this.onMouseEnter)
      triggerElement.addEventListener('mouseleave', this.onMouseLeave)
    })
  }

  didUnmount() {
    this.triggerElements.map(triggerElement => {
      triggerElement.removeEventListener('mouseenter', this.onMouseEnter)
      triggerElement.removeEventListener('mouseleave', this.onMouseLeave)
    })
  }

  onMouseEnter() {
    this.element?.classList.add('hover')
  }

  onMouseLeave() {
    this.element?.classList.remove('hover')
  }
}
